
import React, { FC, useState } from 'react';

interface INoDataMsgProps {
    columnsCount: any;
    msg: any;
}

const NoDataMsg: FC<INoDataMsgProps> = ({ columnsCount, msg }) => {
    return (
        <tr>
            <td colSpan={columnsCount} className="text-center"><br />{msg}</td>
        </tr>
    )
}
export default NoDataMsg;